import React from 'react';
import Project from './Project.jsx';
import '../styles/Projects.css';

const Projects = () => {
  const projectsInfo = {
    one: {
      name: 'Game Dev With Unity',
      desc: 'My Game Development Journey With Unity, Using C# as the programming language',
      // liveLink: 'https://github.com/kunalshah017/Game-With-Unity',
      githubLink: 'https://github.com/kunalshah017/Game-With-Unity',
      techs: ['C#', 'UNITY'],
      currentstatus: 'In Progress',
      isOpenSource: true
    },
    two: {
      name: 'MATRIX Calculator',
      desc: 'Matrix and Determinant Calculator Made With C++ to make operations with matrices and determinants simple',
      liveLink: 'https://www.onlinegdb.com/Nq1d0qksi',
      githubLink: 'https://github.com/kunalshah017/Determinant-Calculator',
      techs: ['C++'],
      currentstatus: 'Completed',
      isOpenSource: true
    },
    three: {
      name: 'Rock Paper Scissor Game in C++',
      desc: 'Console based rock paper scissor game in C++ using randomization',
      liveLink: 'https://www.onlinegdb.com/cuKPC1_o8',
      githubLink: 'https://github.com/kunalshah017/Rock-Paper-Scissors-Game',
      techs: ['C++'],
      currentstatus: 'Completed',
      isOpenSource: true
    },
    four: {
      name: 'ATM - Bank Management System (BETA)',
      desc: 'Console Based ATM - Bank Management System in C++',
      liveLink: 'https://onlinegdb.com/Jbp-8Q-0c',
      githubLink: 'https://github.com/kunalshah017/ATM-Simulator',
      techs: ['C++', 'GitHub Global Campus'],
      currentstatus: 'in Progress',
      isOpenSource: true
    },
    five: {
      name: 'Play With Binaries',
      desc: 'A simple console based program to make binary operations easy and simple, made with C++',
      liveLink: 'https://onlinegdb.com/ByZ1c1d0c',
      githubLink: 'https://github.com/kunalshah017/Play-With-Binaries',
      techs: ['C++', 'GitHub Global Campus'],
      currentstatus: 'in Progress',
      isOpenSource: true
    },
  }
  return (
    <div>
      <h2 align="center">My Projects</h2>
      <div className="Projects" id="projects" >
        <div>
          <Project info={projectsInfo.one} />
          <Project info={projectsInfo.two} />
          <Project info={projectsInfo.three} />
          <Project info={projectsInfo.four} />
          <Project info={projectsInfo.five} />
        </div>
      </div >
    </div>
  )
}

export default Projects;
